export default "__VITE_ASSET__CQPAePK___"